import React from 'react'
import styles from './FullWidthImageViewer.scss'
import _ from 'lodash'

export class FullWidthImageViewer extends React.PureComponent {
  constructor (props) {
    super(props)
    this.state = {
      // vw used to trigger updates, not used in calculation since invoking
      // window.innerWidth directly is more accurate
      vw: window.innerWidth,
      aspect: 1
    }
    this._throttledOnResize = _.throttle(this.onResize, 50)
  }

  componentDidMount () {
    window.addEventListener('resize', this._throttledOnResize)
    if (this._img && this._img.complete) {
      this.setAspect()
    }
  }

  componentWillUnmount () {
    window.removeEventListener('resize', this._throttledOnResize)
  }

  onResize = () => {
    this.setState({vw: window.innerWidth})
  }

  height = () => {
    const vw = window.innerWidth
    return vw / this.state.aspect
  }

  croppedHeight = () => {
    const height = this.height()
    const vh = window.innerHeight
    return Math.min(
      vh * 0.8,
      height,
      600
    )
  }

  setAspect = () => {
    this.setState({aspect: this._img.naturalWidth / this._img.naturalHeight})
  }

  setImg = (img) => {
    this._img = img
  }

  render () {
    const {src} = this.props
    const yCenter = isFinite(this.props.yCenter) ? this.props.yCenter : 0.5

    const height = this.height()
    const croppedHeight = this.croppedHeight()

    // const o = height - croppedHeight
    const oPrime = (height * yCenter - croppedHeight / 2)
    const oMin = 0
    const oMax = height - croppedHeight
    // prevent a negative offsetTop (white showing at top of image)
    const o = Math.min(oMax, Math.max(oMin, oPrime))

    return (
      <div className={styles.FullWidthImageViewer} style={{height: croppedHeight}}>
        <img draggable='false'
          ref={this.setImg}
          onLoad={this.setAspect}
          src={src}
          style={{top: -o + 'px'}} />
      </div>
    )
  }
}
